import { Component } from "@angular/core";
import { Store } from "@ngrx/store";

import { UserService } from "../../services/user.service";
import { closeSideNav } from "../../state/actions/user.actions";
import { selectLogon } from "../../state/selectors/user.selectors";

@Component({
    selector: "pl-user-add-confirmation",
    templateUrl: "./user-add-confirmation.component.html",
    styleUrls: ["./user-add-confirmation.component.scss"],
    standalone: false
})
export class UserAddConfirmationComponent {
  details$ = this.store.select(selectLogon);

  constructor(
    private readonly _userService: UserService,
    private readonly store: Store,
  ) {}

  public closeSideNav() {
    this._userService.updated$.next(true);
    this.store.dispatch(closeSideNav());
  }
}
